import { requestType } from '~/config/enum.config';
var SERVICE = 'dataimp-service';
var CONTROLLER = 'caseInfoConfirmController';
export default {
    /**
     * 案件信息确认
     */
    confirmCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'confirmCaseInfo',
        type: requestType.Post,
    },
    /**
     * 产品信息确认
     */
    confirmProductInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'confirmProductInfo',
        type: requestType.Get,
    },
    /**
     * 客户信息确认
     */
    confirmPersonalInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'confirmPersonalInfo',
        type: requestType.Get,
    },
};
